import { Controller } from "stimulus";

export default class extends Controller {
  static values = {
    url: String,
  };

  declare urlValue: string;

  connect() {
    setTimeout(() => this.syncNotes(), 3000);
  }

  private async syncNotes() {
    if (!this.urlValue) return;

    try {
      const response = await fetch(this.urlValue, {
        headers: { Accept: "application/json" },
      });

      if (!response.ok) return;

      const data = await response.json();

      if (data.replace_content) {
        Object.entries(data.replace_content).forEach(([id, html]) => {
          const el = document.getElementById(id);
          if (el) el.innerHTML = html as string;
        });
      }
    } catch {
      // silently ignore network errors — notes will be fresh on next page visit
    }
  }
}
